import { supabase } from "@/lib/supabase"

export type Theme = "light" | "dark"

const THEMES: Set<string> = new Set<string>(["light", "dark"])

export function isValidTheme(value: unknown): value is Theme {
	return typeof value === "string" && THEMES.has(value)
}

export function saveTheme(theme: Theme) {
	supabase.auth.updateUser({ data: { theme } })
}
